module.exports = __webpack_public_path__ + "img/STARTIMES.6113a7d5.svg";